/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive that updates field errors for all inputs on the form.
 * DO LATER : add unit/integration tests for this directive.
 */
angular.module('bulbApp.validationModule')
.directive('bulbValidationForm', ['$compile', bulbValidationForm]);

function bulbValidationForm($compile) {
    return {
        restrict: 'A',
        require: 'form',
    link: function(scope, elem, attrs, form) {
            // Add novalidate to our forms to disable default browser validation.
            attrs.$set('novalidate', '');

      /**
       * Function to show submit validation errors that are received from the server.
       * @param response Server response containing the errors.
       */
      form.handleRemoteErrors = function(response) {
        if (response.data.errorMap.fieldErrors) {
          scope.$broadcast('bulbRemoteValidationErrors',
            {fieldErrors: response.data.errorMap.fieldErrors, form: this});
        }
      };

      /**
       * Object storing the 'valid' status for each control on the form.
       * @type {{}}
       */
      var statuses = {};

      /**
       * Function to update the valid status for a control on the form.
       *
       * This also updates the overall form valid status based on the value statuses of the form controls.
       *
       * @param control Control name for which the status is being updated.
       * @param value Whether the control is valid or not.
       */
      form.updateStatus = function(control, value) {
        statuses[control] = value;
        var invalid = false;
        angular.forEach(statuses, function(status) {
          if (!status) {
            invalid = true;
          }
        });
        form.bulbInvalid = invalid;
      };
        }
    };
}
